<i18n src="@/locales/modules/RequestTranslate.json"></i18n>

<template>
	<div class="request-advanced-filter">
		<div :key="index" v-for="(field, index) in value" class="my-5 first:mt-0 last:mb-0">
			<!-- TEXT -->
			<!-- TEXTAREA -->
			<div v-if="field.control === $constant.request.control.text || field.control === $constant.request.control.textarea">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ field.title }}:</legend>
				<cbs-input class="inputx w-full" :value="field.value" :placeholder="`${$t('Actions.Input')} ${field.title.toLowerCase()}`" @input="val => handleChangeInput(val, index)" />
			</div>

			<!-- NUMBER -->
			<!-- CALCULATOR -->
			<div v-if="field.control === $constant.request.control.number || field.control === $constant.request.control.calculator">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ field.title }}:</legend>
				<cbs-range-masked-input
					dataType="int"
					class="inputx w-full"
					:value="field.value"
					:userSetting="userSetting"
					:endPlaceholder="`${$t('Actions.Input')} ${$t('EndValue').toLowerCase()}`"
					:beginPlaceholder="`${$t('Actions.Input')} ${$t('StartValue').toLowerCase()}`"
					@input="val => handleChangeInput(val, index)"
				/>
			</div>

			<!-- RADIO -->
			<!-- DROPDOWN -->
			<!-- CHECKBOX -->
			<options-control-filter
				v-if="field.control === $constant.request.control.dropdown || field.control === $constant.request.control.checkbox || field.control === $constant.request.control.radio"
				v-model="value[index]"
			/>

			<!-- RELATION -->
			<relation-control-filter
				v-if="field.control === $constant.request.control.relation"
				v-model="value[index]"
			/>

			<!-- DATETIME PICKER -->
			<div v-if="field.control === $constant.request.control.datetime">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ field.title }}:</legend>
				<cbs-date-range-picker
					type="datetime"
					prefix-icon="''"
					format="dd/MM/yyyy HH:mm"
					value-format="yyyy-MM-dd HH:mm"
					:value="field.value"
					:toPlaceholder="`${$t('Actions.Choose')} ${$t('ToDate').toLowerCase()}`"
					:fromPlaceholder="`${$t('Actions.Choose')} ${$t('FromDate').toLowerCase()}`"
					@change="val => handleChangeInput(val, index)"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

import vSelect from "vue-select";
import OptionsControlFilter from "./OptionsControlFilter";
import RelationControlFilter from "./RelationControlFilter";

export default {
	name: "RequestAdvancedFilter",
	inheritAttrs: false,
	components: {
		vSelect,
		OptionsControlFilter,
		RelationControlFilter
	},
	props: {
		value: {
			type: Array,
			required: true,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return !_.some(prop, obj => {
						if (typeof obj !== "object") {
							return true;
						}
						return !_.has(obj, "id") || !_.has(obj, "title") || !_.has(obj, "attributes") || !_.has(obj, "control") || !_.has(obj, "value");
					});
				}
				return true;
			}
		}
	},
	emits: {
		onFilter: {}
	},
	computed: {},
	watch: {},
	data() {
		const preferences = JSON.parse(this.$store.state.AppActiveUser.preferences);

		return {
			userSetting: preferences
		};
	},
	methods: {
		handleChangeInput(val, index) {
			const cloneValue = _.cloneDeep(this.value);
			cloneValue[index].value = val;
			this.$emit("onFilter", cloneValue);
		},
		setDisableFromDate(date, dateToCompare) {
			if (this.value && dateToCompare) {
				return moment(date).isAfter(moment(dateToCompare));
			}
			return false;
		},
		setDisableToDate(date, dateToCompare) {
			if (this.value && dateToCompare) {
				return moment(date).isBefore(moment(dateToCompare));
			}
			return false;
		}
	}
};
</script>
